<template>
  <textarea
    v-model="model"
    :id="formField.id"
    :style="{ resize: $props.resize }"
    :class="{ error: formField.hasError.value }"
  ></textarea>
</template>

<script setup lang="ts">
import { inject, ref, useAttrs } from 'vue';

import { FORM_FIELD_TOKEN } from './form-field/form-field.token';

const model = defineModel<string | null | undefined>();
const attrs = useAttrs();
const formField = inject(FORM_FIELD_TOKEN, {
  id: attrs.id as string,
  hasError: ref(false),
});

withDefaults(defineProps<{ resize?: 'vertical' | 'horizontal' | 'both' | 'none' }>(), {
  resize: 'vertical',
});
</script>

<style scoped lang="scss">
textarea {
  font: var(--t-typography-body-md-font);
  border-radius: var(--t-border-radius-sm);
  border: 1px solid var(--t-color-border-primary);
  padding: 0.75rem var(--t-spacing-md);
  background-color: var(--t-color-neutral-white);

  &::placeholder {
    color: var(--t-color-neutral-500);
  }

  &.error {
    border-color: var(--t-color-border-danger);
  }

  &:focus {
    color: var(--t-color-neutral-950);
    border-color: var(--t-color-neutral-950);
    box-shadow: var(--t-form-field-focus-shadow);
    outline: none;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    border: none;
    -webkit-text-fill-color: inherit;
    -webkit-box-shadow: 0 0 0px 1000px var(--t-color-neutral-white) inset;
  }
}
</style>
